import type { MappedActivityLogList } from '../ExportActivityLogButton/ExportActivityLogButton';

type SupportedDataTypes = MappedActivityLogList[];

export const convertToCSV = (data: SupportedDataTypes, columnOrder?: (keyof MappedActivityLogList)[]) => {
  if (data.length === 0) {
    return '';
  }
  const order = columnOrder ?? (Object.keys(data[0] || {}) as (keyof MappedActivityLogList)[]);
  const headers = order.join(',');
  const rows = data
    .map((item) =>
      order
        .map((key) => {
          let value = item[key];
          if (typeof value === 'string' && value.includes(',')) {
            value = `"${value}"`;
          }
          return value;
        })
        .join(','),
    )
    .join('\n');

  return `${headers}\n${rows}`;
};
